import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { date } from '@crehana/utils';
import { DefaultConditionalTypesEnum } from "../../conditional-select";
import { TCustomFieldTypeEnum } from "../types";
import { getCategory, getFormType } from "../utils";
var getDefaultInputValue = function getDefaultInputValue(defaultValue, formType) {
  var _defaultValue$values, _defaultValue$values$, _defaultValue$values4, _defaultValue$values5;
  if (!defaultValue || !formType || [TCustomFieldTypeEnum.Multiple, TCustomFieldTypeEnum.Date].includes(formType)) {
    return undefined;
  }
  if (formType === TCustomFieldTypeEnum.Number && ((_defaultValue$values = defaultValue.values) === null || _defaultValue$values === void 0 ? void 0 : (_defaultValue$values$ = _defaultValue$values[0]) === null || _defaultValue$values$ === void 0 ? void 0 : _defaultValue$values$.operator) === DefaultConditionalTypesEnum.RANGE) {
    return defaultValue.values[0].value;
  }
  if (formType === TCustomFieldTypeEnum.Text) {
    var _defaultValue$values2, _defaultValue$values3;
    return (_defaultValue$values2 = defaultValue.values) === null || _defaultValue$values2 === void 0 ? void 0 : (_defaultValue$values3 = _defaultValue$values2[0]) === null || _defaultValue$values3 === void 0 ? void 0 : _defaultValue$values3.value[0];
  }
  return (_defaultValue$values4 = defaultValue.values) === null || _defaultValue$values4 === void 0 ? void 0 : (_defaultValue$values5 = _defaultValue$values4[0]) === null || _defaultValue$values5 === void 0 ? void 0 : _defaultValue$values5.value;
};
export function useDefaultValues(defaultValue) {
  var _defaultValue$values6, _defaultValue$values7, _defaultValue$values0, _defaultValue$values1;
  var defaultCategory = getCategory(defaultValue);
  var defaultFieldId = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.fieldId;
  var defaultFieldLabel = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.fieldLabel;
  var formType = getFormType(defaultValue);
  var defaultSelectedValues = formType === TCustomFieldTypeEnum.Multiple ? defaultValue === null || defaultValue === void 0 ? void 0 : (_defaultValue$values6 = defaultValue.values) === null || _defaultValue$values6 === void 0 ? void 0 : (_defaultValue$values7 = _defaultValue$values6[0]) === null || _defaultValue$values7 === void 0 ? void 0 : _defaultValue$values7.value : undefined;
  var defaultInputValue = getDefaultInputValue(defaultValue, formType);
  var defaultDateValue = function (_defaultValue$values8, _defaultValue$values9) {
    if (formType === TCustomFieldTypeEnum.Date && defaultValue !== null && defaultValue !== void 0 && (_defaultValue$values8 = defaultValue.values) !== null && _defaultValue$values8 !== void 0 && (_defaultValue$values9 = _defaultValue$values8[0]) !== null && _defaultValue$values9 !== void 0 && _defaultValue$values9.value) {
      var _defaultValue$values$2 = _slicedToArray(defaultValue.values[0].value, 2),
        from = _defaultValue$values$2[0],
        to = _defaultValue$values$2[1];
      return {
        tab: to ? 'range' : 'single',
        dates: {
          from: from ? new Date(date.format(from, 'YYYY-MM-DD', 'DD-MM-YYYY')) : undefined,
          to: to ? new Date(date.format(to, 'YYYY-MM-DD', 'DD-MM-YYYY')) : undefined
        }
      };
    }
    return undefined;
  }();
  var defaultConditionalType = defaultValue === null || defaultValue === void 0 ? void 0 : (_defaultValue$values0 = defaultValue.values) === null || _defaultValue$values0 === void 0 ? void 0 : (_defaultValue$values1 = _defaultValue$values0[0]) === null || _defaultValue$values1 === void 0 ? void 0 : _defaultValue$values1.operator;
  return {
    defaultCategory: defaultCategory,
    defaultFieldId: defaultFieldId,
    defaultFieldLabel: defaultFieldLabel,
    defaultSelectedValues: defaultSelectedValues,
    defaultInputValue: defaultInputValue,
    defaultDateValue: defaultDateValue,
    defaultConditionalType: defaultConditionalType,
    defaultFormType: formType
  };
}